module.exports = "images/check.58f43def.png";